import React from 'react';

const Footer = () => (
  <footer id="app-footer">
    &copy; {new Date().getFullYear()}
  </footer>
)
export default Footer;